import { useEffect, useState } from 'react';

// "don't flash the spinner on fast saves" pattern
export function useDelayedFlag(value: boolean, delayMs: number): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!value) {
      setDelayed(false);
      return;
    }

    const handle = window.setTimeout(() => setDelayed(true), delayMs);

    return () => window.clearTimeout(handle);
  }, [value, delayMs]);

  return delayed;
}
